import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { ConservazioneCaricaDocumentoDocumentiBancariStep2Component } from './conservazione-carica-documento-documenti-bancari-step2';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('home.conservazione-carica-documento-documenti-bancari-step2', {
            url: '/conservazione-carica-documenti-bancari',
            ncyBreadcrumb: {
                label: 'Carica Documenti Bancari',
                parent: 'home.conservazione'
            },
            data: {
                authorisationLevel: 1,
                pageTitle: 'Conservazione Carica Documento'
            },
            'views': {
                'homeContent': {
                    template: '<conservazione-carica-documento-documenti-bancari-step2 flex="100"></conservazione-carica-documento-notifiche-sdi-step2>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const ConservazioneCaricaDocumentoDocumentiBancariStep2Module: string = ng
    .module('conservazione-carica-documento-documenti-bancari-step2', [
        'ui.bootstrap',
        uiRouter,
    ])
    .component('conservazioneCaricaDocumentoDocumentiBancariStep2', ConservazioneCaricaDocumentoDocumentiBancariStep2Component)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/conservazione-carica-documenti-bancari-step2/conservazione-carica-documento-documenti-bancari-step2.module.ts